import { Grid, Box, Button, Stack } from "@mui/material";
import { Icon } from "components/Icons";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next'
import { get, getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { useActiveUnit } from "./hooks";
import { useOpenHouseDrawer } from "components/Contact/useOpenHouseDrawer";
import { MDay, Month, WDay } from "components/OpenHouseBanner/OpenHouseBanner.utilities";
import { _bootstrap } from "state/store.bootstrap";

function WebOpenHouse() {
  const textRef = useRef(null);
  const unit = useActiveUnit();
  const unitId = parseInt(unit.getId());
  const [isAddrExpanded, setIsAddrExpanded] = useState(false)

  const { open } = useOpenHouseDrawer();
  
  const [cOpHouse, setCOphouse] = useState({})
  const sitename   = useGet(_bootstrap).sitename

  const openhouses = get(_project, 'openhouses')
  const { i18n:{language} } = useTranslation()

  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  useEffect(()=> {
    if (textRef.current) {
      const width = textRef.current.getBoundingClientRect().width;
      if((width + 16) > 270) {
        setIsAddrExpanded(true)
      }
    }
  }, [unitId])

    useEffect(()=> {
      if(openhouses?.length) {
        const opHsg = openhouses[0]
          const Y = sitename ?? ''
          const A = opHsg?.FromDate    || ''
          const P = opHsg?.FromDate    || ''  // Remember safari requires specific format of dates
          const X = opHsg?.Title       || ''
          const W = opHsg?.FromTime    || ''
          const V = opHsg?.ToTime      || ''
          const I = opHsg?.Address     || ''
          const Q = `${MDay(P) ?? ''}`
          const R = `${Month(P) ?? ''}`
          const T = `${WDay(P)[0].toUpperCase() + WDay(P).slice(1).toLowerCase()} ${buttonsLabel?.filter( btn => btn?.UILabelProperty == 'kl')[0]?.Label} ${W} - ${V}`
          const S = `${Y}`

          setCOphouse({
              MM         : Q,
              MMM        : R,
              Time       : T,
              Title      : S,
              Address    : I
          })
      }
    }, [openhouses])

  const handleOpenHouseForm = () => {
    open(unit);
  };
  
  return (
    <>
      { Boolean(openhouses?.length) && (
        <Box sx={{ width: '100%', background: '#fff', border: '4px solid #fff', borderRadius: '16px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', padding: '16px 48px 16px 16px' }}>
          <Stack direction="row" sx={{ minHeight: "104px", lineHeight: 1.3, borderRadius: "16px",  width:"100%" ,  background:"#FFFFFF"}} >
            {/* left */}
            <Box sx={{paddingRight:"16px", borderRight: "1px solid", minWidth: "77px", borderRightColor: "common.black", textAlign: "center", lineHeight: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: 'center' }} >
              <Box sx={{ fontSize: 35, fontWeight: "bold", mb: "2px", }} >
                {cOpHouse?.MM}
              </Box>
              <Box sx={{ fontSize: 16, }} >
                {cOpHouse?.MMM}
              </Box>
            </Box>
            {/* right */}
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" ,paddingLeft:"16px"}}>
              <strong className="paragraph1-bold">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'OpenHouseTitle')[0]?.Label} {cOpHouse?.Title}</strong>
              <div className="paragraph2-light">{cOpHouse?.Time}</div>
              <div ref={textRef} className="paragraph2-light" style={{ width: 'fit-content'}}>
                { cOpHouse?.Address }
              </div>
              {/* commented unit we get a proper openhouse link */}
              <Button onClick={handleOpenHouseForm} className="paragraph1-light" sx = {{ px: 0, py: 0.5, justifyContent: "flex-start", width: "fit-content", color: f_clr.ctaPrimary }} endIcon = {<Icon icon="long-arrow" />} >
                { buttonsLabel?.filter( btn => btn.UILabelProperty === 'OpenHouseBtnLabel')[0]?.Label || "Tilmeld åbent hus" }
              </Button>
            </Box>
          </Stack>
        </Box>
      )}
    </>
  );
}

export default WebOpenHouse;
